var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"state","title":"State List"}},[(_vm.isMobile)?_c('m-geo-state',{attrs:{"geoType":2}}):_c('m-geo-state-box',{attrs:{"geoType":2}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10525606","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoState.vue
// module id = null
// module chunks = 